import type { ElementRef } from '@angular/core'
import { InjectionToken } from '@angular/core'

export const INTERSECTION_ROOT = new InjectionToken<ElementRef<Element>>('[WA_INTERSECTION_ROOT]')
